/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { Component, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import {
  Box,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import AddIcon from '@mui/icons-material/Add';

import { CustomFilterV2, TableV2 } from '../../../components/v2';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsAportes from '../../../store/aporte/reducer';
import * as actionsAportes from '../../../store/aporte/actions';
import * as Role from '../../../constants/role';
import Formulario from './Formulario';
import ResumoCards from './ResumoCards';

class CardsErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

CardsErrorBoundary.propTypes = {
  children: PropTypes.node,
};

const defaultFilter = () => ({
  inicio: moment().startOf('week').valueOf(),
  fim: moment().endOf('day').valueOf(),
});

const AportesV2 = ({ aportes, loadAportes, userRole, history, authData }) => {
  const [open, setOpen] = useState(false);
  const [localFilter, setLocalFilter] = useState(defaultFilter);
  const [openFilter, setOpenFilter] = useState(false);
  const [reload, setReload] = useState(false);
  const [activeCard, setActiveCard] = useState(null);

  const isAdmin = () => Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole;

  useEffect(() => {
    if (!isAdmin()) history.push(`/v2/aporte/${authData.id}`);
  }, [authData]);

  useEffect(() => {
    loadAportes(localFilter);
  }, [loadAportes]);

  const filteredRows = useMemo(() => {
    if (!aportes) return [];
    if (activeCard === 'NEGATIVO' || activeCard === 'VALOR_NEGATIVO') {
      return aportes.filter((a) => a.valor < 0);
    }
    return aportes;
  }, [aportes, activeCard]);

  const onView = (id) => {
    history.push(`/v2/aporte/${id}`);
  };

  const onAdd = () => {
    setOpen(true);
  };

  const onClose = (isSave) => {
    if (isSave) {
      loadAportes(localFilter);
      setReload((r) => !r);
    }
    setOpen(false);
  };

  const headerActions = [];
  if (isAdmin()) {
    headerActions.push({
      label: 'Novo',
      onClick: onAdd,
      startIcon: <AddIcon />,
      variant: 'contained',
    });
  }

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
          sx={{ pr: 2 }}
        >
          <Typography variant="h4">Aportes</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <CardsErrorBoundary>
          <ResumoCards
            apiFilter={localFilter}
            activeCard={activeCard}
            onFilterByCard={setActiveCard}
            refreshKey={reload}
          />
        </CardsErrorBoundary>

        <TableV2
          rows={filteredRows}
          rowHeight={56}
          headerActions={headerActions}
          columns={[
            {
              field: 'usuarioName',
              headerName: 'Inspetor/Observador',
              flex: 1,
              minWidth: 200,
            },
            {
              field: 'valor',
              headerName: 'Valor em Caixa',
              width: 160,
              renderCell: ({ row }) => {
                if (row.valor == null) return '—';
                const isNegative = row.valor < 0;
                return (
                  <Typography
                    variant="body2"
                    sx={{
                      color: isNegative ? 'error.main' : 'success.main',
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    {row.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  </Typography>
                );
              },
            },
            {
              field: 'dataUltimoAporte',
              headerName: 'Último Aporte',
              width: 160,
              renderCell: ({ row }) =>
                row.dataUltimoAporte
                  ? moment(Number(row.dataUltimoAporte)).format('DD/MM/YYYY')
                  : '---',
            },
            {
              field: 'dataUltimoGasto',
              headerName: 'Último Gasto',
              width: 160,
              renderCell: ({ row }) =>
                row.dataUltimoGasto
                  ? moment(Number(row.dataUltimoGasto)).format('DD/MM/YYYY')
                  : '---',
            },
          ]}
          onView={onView}
          canDelete={() => false}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          fields={[
            { field: 'useInspetor', md: 12 },
          ]}
          defaultFilter={defaultFilter()}
          onFilter={(filterData) => {
            setActiveCard(null);
            setLocalFilter(filterData);
            loadAportes(filterData);
            setOpenFilter(false);
          }}
        />

        <Formulario
          id={null}
          open={open}
          onClose={onClose}
          isAdmin={isAdmin()}
        />
      </Stack>
    </Box>
  );
};

AportesV2.propTypes = {
  loadAportes: PropTypes.func.isRequired,
  aportes: PropTypes.array,
  userRole: PropTypes.string.isRequired,
  authData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  userRole: selectorsAuth.getRole(state),
  authData: selectorsAuth.getAuth(state),
  aportes: selectorsAportes.getAportes(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsAportes,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AportesV2));
